import React, { PureComponent } from 'react';
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import './find.css';
import logoPic from 'images/index/logo.png';
import GlobalHeader from 'components/GlobalHeader'
import GlobalFooter from 'components/GlobalFooter'
import { Link } from 'react-router-dom';
import { Message } from 'element-react';

export default class ResetPassword extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            images: [],
            form: {
                type: '',
                remember: '',
                username: '',
                grant_type: "captcha",
                verificationCode: '',
                uid: '',
            },
        }
    }

    uuid(len, radix) {
        let { verificationCode, uid, form } = this.state;
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [],
            i;
        radix = radix || chars.length;
        if (len) {
            // Compact form
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
        } else {
            // rfc4122, version 4 form
            var r;
            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23];
            uuid[14] = '4';
            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 32; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random() * 16;
                    uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                }
            }
        }
        let uid1 = uuid.join('');
        let { from } = form;
        form.uid = uid1;

        verificationCode = Request.getDebugUrl() + 'blade-auth/oauth/verificationCode?uid=' + uid1;
        this.setState({ verificationCode: verificationCode, form: form });
    }
    componentDidMount() {
        this.uuid()
    }

    step=(e)=>{
        console.log(e);
        let { form } = this.state;
        var phone = this.refs.phone.value;
        var code = this.refs.code.value;
        //手机号码校验
        var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if(phone == ''){
            Message.error("手机号码不能为空");
            return false;
        }
        if (!myreg.test(phone)) {
            Message.error("请输入正确的手机号码");
            return false;
        } 
        if(code == ''){
            Message.error("验证码不能为空");
            return false;
        }
        
        let params = {
            uid: form.uid,
            verificationCode: code
        };
        Http.get(Request.getDebugUrl() + 'blade-auth/oauth/checkVerificationCode', params, obj => {
            console.log("verificationCode==",obj);
            if (obj && obj.code == 200) {
                this.props.history.replace("/step?phone=" + phone)
            }else {
                Message.error("验证码不正确");
                return false;
            }
        });
        
    }

    render() {
        let { form, verificationCode, uid } = this.state;
        return (
            <div>
                <GlobalHeader history={this.props.history} />

                <div className="main_find">
                    {/* {this.renderLIst()} */}
                    {/* {内容区域*/}
                    <div className="center">
                        <div className="content">
                            <div className="content_box_find">
                                <div className="content_box_title">帐号安全</div>
                                <div className="content_box_change">找回密码</div>
                                <div className="content_box_phone" style={{ width: '400px' }}>
                                    <input ref="phone" placeholder="手机号" maxlength='11'></input>
                                </div>
                                <div style={{ width: '400px', margin: '0 auto', height: '50px' }}>
                                    <input ref="code" className="check_code" placeholder="验证码" />
                                    {/* </input><input className="content_box_code" value="1232" /> */}
                                    {/* <img class="content_box_code" src="http://yhbest.imwork.net:30080/blade-auth/oauth/verificationCode?uid=D755F73D332E2847759B5B953ED6CCED" /> */}
                                    <img className="content_box_code" src={verificationCode} onClick={() => this.uuid()}/>
                                    <div className="content_box_click" onClick={() => this.uuid()}>
                                        <span>换一张</span>
                                    </div>
                                </div>

                                <div className="content_box_login" onClick={this.step.bind(this)}><span>下一步</span></div>
                            </div>
                        </div>
                    </div>

                    {/*内容区域} */}
                    <GlobalFooter />


                </div>
            </div>
        )
    }
}